import { Chip } from "@mui/material";
import { getLuminance } from "@mui/system";

const CONTRAST_THRESHOLD = 0.5;

type ColoredLabelChipProps = {
	label: string;
	color: string;
	icon?: React.ReactElement;
	size?: "small" | "medium";
};

export const ColoredLabelChip = ({ label, color, icon, size = "small" }: ColoredLabelChipProps) => {
	const textColor = getLuminance(color) > CONTRAST_THRESHOLD ? "rgba(0, 0, 0, 0.87)" : "#fff";
	return (
		<Chip
			label={label}
			icon={icon}
			size={size}
			sx={{
				fontWeight: 600,
				backgroundColor: color,
				color: textColor,
				px:1,
				"& .MuiChip-icon": { color: "inherit" },
			}}
		/>
	);
};
